import {
  Button, message, Modal, Pagination, Space, Table,
} from 'antd';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import useTranslation from '../../../hooks/translation/useTranslation';

const columns = [
  {
    title: 'name_ka',
    dataIndex: 'name_ka',
    key: 'name_ka',
  },
  {
    title: 'name_en',
    dataIndex: 'name_en',
    key: 'name_en',
  },
  {
    title: 'name_ru',
    dataIndex: 'name_ru',
    key: 'name_ru',
  },
  {
    title: 'edit',
    dataIndex: 'edit',
    key: 'edit',
  },
  {
    title: 'delete',
    dataIndex: 'delete',
    key: 'delete',
  },
];

function OrganizationTypes() {
  const { trans } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [render, setRender] = useState(false);
  const [page, setPage] = useState(1);

  useEffect(() => {
    axios.get('/api/organization-types', { params: { page } }).then((res) => {
      if (res.data?.status === 'success') {
        setData(res?.data?.organization_types);
      }
    });
  }, [render, page]);

  const deleteType = (id) => {
    message
      .loading(
        trans('customer_delete_in_progress'),
        axios
          .delete(`/api/organization-types/${id}`)
          .then((res) => {
            if (res?.data.status === 'success') {
              setRender(!render);
            }
          }),
      )
      .then(() => setTimeout(
        () => message.success(
          trans('customer_successfully_deleted'),
        ),
        400,
      ));
  };

  const checkIfDelete = (id, name) => {
    Modal.confirm({
      title: trans('delete_customer'),
      content: `თქვენ ნამდვილად გსურთ, რომ ${name} წაშალოთ?`,
      okText: trans('yes'),
      onOk: () => deleteType(id),
      cancelText: trans('no'),
    });
  };

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <Button type="primary" onClick={() => navigate('/admin/organization-types/add')}>
        {trans('add_organization_type')}
      </Button>
      <div className="overflow-table">
        <Space size="large" direction="vertical" style={{ width: '100%' }}>
          <Table
            pagination={false}
            dataSource={data?.data?.map((type) => ({
              key: type.id,
              name_ka: type?.name_ka,
              name_en: type?.name_en,
              name_ru: type?.name_ru,
              edit: (
                <Button
                  onClick={() => navigate(`/admin/organization-types/${type.id}/edit`)}
                >
                  {' '}
                  {trans('edit')}
                </Button>
              ),
              delete: (
                <Button
                  type="danger"
                  onClick={() => checkIfDelete(type?.id, type?.name_ka)}
                >
                  {trans('delete')}
                </Button>
              ),
            }))}
            columns={columns.map(
              (col) => ({
                ...col,
                title: trans(col.title),
              }),
            )}
          />
          {data
              && (
              <Pagination
                total={data?.meta?.totalItems}
                pageSize={data?.meta?.itemsPerPage}
                current={page}
                onChange={(e) => setPage(e)}
              />
              )}
        </Space>
      </div>
    </Space>
  );
}

export default OrganizationTypes;
